/** @jsxImportSource @emotion/react */
import useResponsive from "../../../../../hooks/useResponsive";

export default function Year2019() {
  const { isMobile } = useResponsive();
  return (
    <div css={yearStyle(isMobile)}>
      <div css={textBox(isMobile)}>
        <p css={numberText(isMobile)}>07</p>
        <p css={text(isMobile)}>주식회사 서르 설립</p>
      </div>
    </div>
  );
}

const yearStyle = (isMobile: boolean) => ({
  display: "flex",
  flexDirection: "column" as const,
  gap: "10px",
  marginTop: isMobile ? "527px" : "598px",
  marginBottom: isMobile ? "150px" : undefined,
});

const textBox = (isMobile: boolean) => ({
  display: "flex",
  flexDirection: "row" as const,
  gap: isMobile ? "15px" : "30px",
});

const numberText = (isMobile: boolean) => ({
  fontSize: isMobile ? "14px" : "20px",
  fontWeight: 700,
  lineHeight: "27px",
  textAlign: "center" as const,
  color: "white",
});

const text = (isMobile: boolean) => ({
  fontSize: isMobile ? "14px" : "18px",
  fontWeight: 400,
  lineHeight: "27px",
  textAlign: "left" as const,
  color: "white",
});
